/**
 * @generated SignedSource<<b499cfdf3d3a3e6c74892f428ad9febf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type graphUtils_ujVersions$data = {
  readonly versions: ReadonlyArray<{
    readonly details: string | null;
    readonly start: any;
    readonly steps: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    }>;
    readonly summary: string;
  }>;
  readonly " $fragmentType": "graphUtils_ujVersions";
};
export type graphUtils_ujVersions$key = {
  readonly " $data"?: graphUtils_ujVersions$data;
  readonly " $fragmentSpreads": FragmentRefs<"graphUtils_ujVersions">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "timeRange"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "graphUtils_ujVersions",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "timeRange",
          "variableName": "timeRange"
        }
      ],
      "concreteType": "UJVersion",
      "kind": "LinkedField",
      "name": "versions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "start",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "summary",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "details",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Step",
          "kind": "LinkedField",
          "name": "steps",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UserJourney",
  "abstractKey": null
};

(node as any).hash = "0ccdacd31904bbde806e91e18ed364af";

export default node;
